(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ravzelo-prestige-inspired"] && !Shopify.designMode) return;
  try {
    
  const roots = document.querySelectorAll('[data-rv-prestige]');
  roots.forEach((root) => {
    const slides = root.querySelectorAll('.rv-prestige__slide');
    const buttons = root.querySelectorAll('.rv-prestige__dots button');
    const header = root.querySelector('.rv-prestige__header');
    const shopNav = root.querySelector('.rv-prestige__shop-nav');
    const mega = root.querySelector('.rv-prestige__mega');
    const mobileMenu = root.querySelector('[data-rv-mobile-menu]');
    const mobileMenuOpen = root.querySelector('[data-rv-mobile-menu-open]');
    const heroVideo = root.querySelector('.rv-prestige__hero-video');
    let active = 0;
    let closeTimer;
    const isMobileHero = () => window.matchMedia('(max-width: 640px)').matches;
    const loadMobileSlideImage = (slide) => {
      const image = slide && slide.querySelector('[data-rv-mobile-src]');
      if (!image) return;
      image.src = image.dataset.rvMobileSrc;
      image.removeAttribute('data-rv-mobile-src');
    };
    const show = (index) => {
      active = index;
      loadMobileSlideImage(slides[active]);
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === active));
      buttons.forEach((button, buttonIndex) => button.classList.toggle('is-active', buttonIndex === active));
    };
    buttons.forEach((button, index) => button.addEventListener('click', () => show(index)));
    if (slides.length > 1 && !isMobileHero()) {
      window.setInterval(() => show((active + 1) % slides.length), 6500);
    }
    const pageWrapper = document.querySelector('.page-wrapper');
    const getScrollTop = () => pageWrapper?.scrollTop || window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const syncHeader = () => {
      if (!header) return;
      header.classList.toggle('is-solid', getScrollTop() > 8);
    };
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
    pageWrapper?.addEventListener('scroll', syncHeader, { passive: true });
    document.addEventListener('scroll', syncHeader, { passive: true });
    window.addEventListener('resize', syncHeader, { passive: true });
    window.addEventListener('pageshow', syncHeader);
    window.requestAnimationFrame(syncHeader);
    if (heroVideo) {
      const syncVideoLabel = () => heroVideo.setAttribute('aria-label', heroVideo.paused ? 'Play campaign video' : 'Pause campaign video');
      const toggleVideo = () => {
        if (heroVideo.paused) {
          heroVideo.play().catch(() => {});
        } else {
          heroVideo.pause();
        }
        syncVideoLabel();
      };
      heroVideo.tabIndex = 0;
      heroVideo.addEventListener('click', toggleVideo);
      heroVideo.addEventListener('play', syncVideoLabel);
      heroVideo.addEventListener('pause', syncVideoLabel);
      heroVideo.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggleVideo();
      });
      syncVideoLabel();
    }
    if (mobileMenu && mobileMenuOpen) {
      const closeMobileMenu = () => {
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileMenuOpen.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('rv-prestige-mobile-menu-is-open');
      };
      const openMobileMenu = () => {
        mobileMenu.classList.add('is-open');
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileMenuOpen.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('rv-prestige-mobile-menu-is-open');
      };
      mobileMenuOpen.addEventListener('click', openMobileMenu);
      mobileMenu.addEventListener('click', (event) => {
        if (event.target.closest('[data-rv-mobile-menu-close]') || event.target.closest('.rv-prestige-mobile-menu__nav a')) closeMobileMenu();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMobileMenu();
      });
    }
    if (shopNav && mega) {
      const openMega = () => {
        window.clearTimeout(closeTimer);
        shopNav.classList.add('is-open');
      };
      const closeMega = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => shopNav.classList.remove('is-open'), 220);
      };
      shopNav.addEventListener('mouseenter', openMega);
      shopNav.addEventListener('mouseleave', closeMega);
      mega.addEventListener('mouseenter', openMega);
      mega.addEventListener('mouseleave', closeMega);
      shopNav.addEventListener('focusin', openMega);
      shopNav.addEventListener('focusout', closeMega);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ravzelo-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rz-product]').forEach((root) => {
    const variantsScript = root.querySelector('[data-rz-product-variants]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
    const optionInputs = root.querySelectorAll('[data-option-index]');
    const variantIdInput = root.querySelector('[data-rz-variant-id]');
    const galleries = root.querySelectorAll('[data-variant-gallery]');
    const productForm = root.querySelector('.rz-product__form');
    const submitButton = productForm?.querySelector('button[type="submit"]');
    const priceElement = root.querySelector('[data-rz-price]');
    const comparePriceElement = root.querySelector('[data-rz-compare-price]');
    const cartDrawer = root.querySelector('[data-rz-cart-drawer="product"]');
    const cartTrigger = root.querySelector('[data-rz-cart-open="product"]');

    const findSelectedVariant = () => {
      if (!variants.length) return null;
      const selectedOptions = [];
      optionInputs.forEach((input) => {
        if (input.checked) selectedOptions[Number(input.dataset.optionIndex)] = input.value;
      });
      return variants.find((variant) => {
        return selectedOptions.every((value, index) => value === undefined || variant.options[index] === value);
      }) || null;
    };

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      return `$${amount.toFixed(2)}`;
    };

    const selectedColorValue = () => {
      const colorInput = root.querySelector('[data-is-color-option="true"] input:checked');
      return colorInput?.value || '';
    };

    const syncSelectedVariant = () => {
      const selectedVariant = findSelectedVariant();
      if (selectedVariant && variantIdInput) variantIdInput.value = selectedVariant.id;
      if (selectedVariant && priceElement) priceElement.textContent = formatMoney(selectedVariant.price);
      if (selectedVariant && comparePriceElement) {
        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          comparePriceElement.textContent = formatMoney(selectedVariant.compare_at_price);
          comparePriceElement.style.display = '';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }
      if (submitButton) {
        submitButton.disabled = Boolean(selectedVariant && !selectedVariant.available);
        submitButton.textContent = selectedVariant && !selectedVariant.available ? 'Sold out' : 'Add to cart';
      }
      const colorValue = selectedColorValue();
      if (selectedVariant || colorValue) {
        let matchedColorGallery = false;
        galleries.forEach((gallery) => {
          const isColorMatch = colorValue && gallery.dataset.colorGallery === colorValue && !matchedColorGallery;
          gallery.classList.toggle('is-active', Boolean(isColorMatch));
          if (isColorMatch) matchedColorGallery = true;
        });
      }
    };

    const openCartDrawer = () => {
      if (!cartDrawer) return;
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rz-cart-drawer-is-open');
      cartDrawer.getBoundingClientRect();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          cartDrawer.classList.add('is-open');
          cartDrawer.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('rz-cart-drawer-is-open');
        });
      });
    };

    const refreshCartDrawer = async () => {
      if (!cartDrawer) return;
      const response = await fetch(window.location.href, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
      });
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const freshDrawer = parsed.querySelector('[data-rz-cart-drawer="product"]');
      if (freshDrawer) {
        cartDrawer.innerHTML = freshDrawer.innerHTML;
      }
    };

    const refreshCartCount = async () => {
      if (!cartTrigger) return;
      const response = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await response.json();
      cartTrigger.textContent = `Cart (${cart.item_count})`;
    };

    if (productForm) {
      productForm.addEventListener('submit', async (event) => {
        if (submitButton?.disabled) return;

        event.preventDefault();
        if (submitButton) submitButton.disabled = true;

        try {
          const formData = new FormData(productForm);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });

          if (!response.ok) {
            productForm.submit();
            return;
          }

          await Promise.all([refreshCartDrawer(), refreshCartCount()]);
          openCartDrawer();
        } catch (error) {
          productForm.submit();
        } finally {
          if (submitButton) submitButton.disabled = false;
        }
      });
    }

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const group = input.closest('[data-rz-option-group]');
        group?.querySelectorAll('.rz-product__swatch, .rz-product__size').forEach((option) => {
          option.classList.toggle('is-active', option.contains(input));
        });
        syncSelectedVariant();
      });
    });
    syncSelectedVariant();
  });

  } catch(e) { console.error(e); }
})();
})();
